import {combineReducers} from 'redux'
import {routerReducer} from 'react-router-redux'
import { reducer as form } from 'redux-form'
import session from './session'
import modals from './modals'
import user from './user'
import signinMethods from './signinMethods'
import sections from './sections'
import archivedSections from './archivedSections'
import recentActivities from './recentActivities'
import questions from './library/questions'
import questionsRefreshedTimestamp from './library/questionsRefreshedTimestamp'
import sets from './library/sets'
import setsRefreshedTimestamp from './library/setsRefreshedTimestamp'
import archivedQuestions from './library/archivedQuestions'
import folders from './library/folders'
import archivedFolders from './library/archivedFolders'
import archivedSets from './library/archivedSets'
import questionPollsRefreshedTimestamp from './polls/questionPollsRefreshedTimestamp'
import setPollsRefreshedTimestamp from './polls/setPollsRefreshedTimestamp'
import queueQuestionPolls from './polls/queue/queueQuestionPolls'
import queueSetPolls from './polls/queue/queueSetPolls'
import historyQuestionPolls from './polls/history/historyQuestionPolls'
import historySetPolls from './polls/history/historySetPolls'
import control from './control'
import sectionControls from './sectionControls'
import meta from './meta'
import notification from './notification'
import hasLiveViewNotification from './hasLiveViewNotification'
import service from './service'
import planRestrictions from './planRestrictions'
import billing from './billing'
import invoices from './invoices'
import clockSyncOffset from './clockSyncOffset'
import geoInfo from './geoInfo'
import scoreSheetCustomDateRange from './scoreSheetCustomDateRange'
import mobileInfo from './mobileInfo'
import upcomingInvoice from './upcomingInvoice'
import onboardingWizardDismissed from './onboardingWizardDismissed'
import repos from './repos'
import permissions from './permissions'
import locks from './locks'
import searchKey from './searchKey'
import setsPreview from './library/setsPreview'
import questionsPreview from './library/questionsPreview'
import foldersPreview from './library/foldersPreview'
import discounts from './discounts'
import backToSchoolModal from './backToSchoolModal'
import order from './order'

import requestedRepos from './requestedRepos'

import requestedSets from './requestedSets'
import requestedQuestions from './requestedQuestions'
import userProfiles from './userProfiles'
import requestedUserProfiles from './userProfiles'
import authorRepos from './authorRepos'
import reposFollowerCount from './reposFollowerCount'
import reviews from './reviews'
import adminRepos from './adminRepos'
import adminCreators from './adminCreators'
import submissions from './submissions'
import adminSubmissions from './adminSubmissions'
import adminAwards from './adminAwards'
import proposedControl from './proposedControl'
import sectionAuthorizations from './sectionAuthorizations'
import sectionPresenceMembers from './sectionPresenceMembers'
import integrations from './integrations'


import requestedRepoContent from './requestedRepoContent'
import discoverLatestRepos from './discoverLatestRepos'
import previewItem from './previewItem'


const rootReducer = combineReducers({
	integrations,
	previewItem,
	sectionAuthorizations,
	discoverLatestRepos,
	sectionPresenceMembers,
	submissions,
	proposedControl,
	adminAwards,
	adminSubmissions,
	adminRepos,
	adminCreators,
	service,
	reviews,
	authorRepos,
	reposFollowerCount,
	userProfiles,
	requestedUserProfiles,
	requestedRepos,
	requestedSets,
	requestedQuestions,
	order,
	backToSchoolModal,
	setsPreview,
	questionsPreview,
	foldersPreview,
	locks,
	searchKey,
	repos,
	permissions,
	discounts,
	upcomingInvoice,
	clockSyncOffset,
	mobileInfo,
	billing,
	invoices,
	planRestrictions,
	scoreSheetCustomDateRange,
	hasLiveViewNotification,
	questionPollsRefreshedTimestamp,
	setPollsRefreshedTimestamp,
	notification,
	meta,
	sectionControls,
	signinMethods,
	archivedSections,
	folders,
	archivedFolders,
	sets,
	setsRefreshedTimestamp,
	archivedSets,
	questions,
	questionsRefreshedTimestamp,
	archivedQuestions,
	queueQuestionPolls,
	queueSetPolls,
	historyQuestionPolls,
	historySetPolls,
	control,
	geoInfo,
	onboardingWizardDismissed,
	session,
	form,
	user,
	sections,
	modals,
	recentActivities,
	requestedRepoContent,
	routing:routerReducer})

export default rootReducer